module.exports = __webpack_public_path__ + "static/media/Recurso6.60a4e08f.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Logo/img/Recurso6.png
// module id = 2616
// module chunks = 0